export const IAS_PEDAGOGY = {
  BASE_URL: "https://www.iasjnani.com",
  TOTAL_INTAKE: "70",
  TOTAL_FEES: "₹75,000/- (all taxes included)",
  COURSE_DURATION: "7",
  WHATSAPP_CHANNEL: "https://whatsapp.com/channel/0029Vb9wBwtBlHpZZAYOwM1q",
  OFFICE_PHONE: "+91-9482936712",
  PHONE_CONTACT2: "+91-8618047043",
  CONTACT_EMAIL: "contact@iasjnani.com",
  WHATSAPP_CHAT: "919482936712",
  WHATSAPP_CHAT_MESSAGE:
    "Hello, I am interested in joining IAS Jnani. Please share more details.",
  INSTAGRAM: "https://www.instagram.com/iasjnani",
  YOUTUBE: "https://www.youtube.com/@iasjnani",
  ADDRESS:
    "IAS Jnani, 1nd Floor, Kanyakumari High School, Kengunte Circle, Next to JS Pre-University College, Bangalore - 560056",
  SHARE_COURSE: `https://www.iasjnani.com/course`,
  SHARE_BLOG: `https://www.iasjnani.com/blog`,
  YOUTUBE_INTRO: "7upsPMWFwL4",
  YOUTUBE_COURSE: "https://www.youtube.com/watch?v=h8N3ZFmXAUw",
};

export const SHARE_CURRENT_COURSE = `https://wa.me/?text=${encodeURIComponent(
  "Check out this amazing UPSC course: " + IAS_PEDAGOGY.SHARE_COURSE
)}`;

export const SHARE_CURRENT_BLOG = `https://wa.me/?text=${encodeURIComponent(
  "Check out this UPSC blog from IAS Jnani: " + IAS_PEDAGOGY.SHARE_BLOG
)}`;
